import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import React from 'react';
import { getLinkTarget } from '@mirohq-internal/website-utils';
import { Icons } from '../icons/icons.esm.js';
import { useTemplateLoader } from '../template-loader/template-loader.esm.js';
import { LinkBase } from './link-base/link-base.esm.js';

const Anchor = /*#__PURE__*/ React.forwardRef(({ children, circularBg, className, iconStart, variant, iconEnd, onClick, templateId, disableTextTruncation, ...rest }, ref)=>{
    /**
     * Only non fixed width links can have start icons
     */ const StartIcon = Icons?.[`${iconStart}`];
    const EndIcon = Icons?.[`${iconEnd}`];
    const { setSelectedTemplate } = useTemplateLoader();
    return jsxs(LinkBase, {
        ref: ref,
        variant: variant || 'anchor',
        target: getLinkTarget(rest.href || ''),
        onClick: (event)=>{
            if (templateId) {
                /**
                 * If `templateId` is specified, we will override the default behaviour
                 * of the click handler in order to trigger the account picker
                 *
                 * TODO: Move this to the Cta module
                 */ event.preventDefault();
                setSelectedTemplate({
                    metadataId: templateId
                });
                return;
            }
            onClick?.(event);
        },
        className: classNames(className, {
            'link-anchor-circular-bg': circularBg
        }),
        ...rest,
        children: [
            StartIcon && jsx(StartIcon, {
                size: rest?.size || 'inherit'
            }),
            children && jsx("span", {
                className: classNames({
                    'd-inline-block text-truncate': !disableTextTruncation
                }),
                children: children
            }),
            EndIcon && jsx(EndIcon, {
                size: rest?.size || 'inherit'
            })
        ]
    });
});

export { Anchor };
